import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  templateImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  // Compact "Loading PDF..." shown inside a cover thumbnail while it loads.
  thumbLoading: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    boxSizing: 'border-box',
    textAlign: 'center'
  },
  // Renders a cover-page PDF's first page as the thumbnail.
  templateDoc: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    // Let hover / clicks fall through to the card so the pointer never
    // flickers over react-pdf's canvas / layers.
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Let the react-pdf wrapper fill the thumb so the loading label centers.
    '& .react-pdf__Document': {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '& .react-pdf__Page': {
      display: 'flex',
      justifyContent: 'center',
      background: 'transparent'
    },
    '& canvas': {
      width: '100% !important',
      height: 'auto !important',
      display: 'block'
    },
    '& .react-pdf__Page__textContent, & .react-pdf__Page__annotations': {
      display: 'none'
    }
  }
});
